import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Returns the date of the last sunday in given month
 * @param {number} month is the month number starting from 0 (january)
 * @param {number} lastDayOfMonth start either from 31 or 30 depending on the value of month
 * @returns {DayJs} dayjs object
 */
const getLastSundayOfMonth = (month: number) => {
  const day = dayjs().month(month - 1).daysInMonth();
  let lastDayOfMonth = dayjs.tz(`${dayjs().year()}-${month}-${day}`, 'Europe/Amsterdam').startOf('day');

  while (lastDayOfMonth.day() !== 0) {
    lastDayOfMonth = lastDayOfMonth.subtract(1, 'day');
  }
  lastDayOfMonth = lastDayOfMonth.hour(2);
  return lastDayOfMonth;
}
/**
 * @param {boolean} DSTorST is a boolean value indicating if its currently daylightsaving time or standard time
 * @returns {boolean} if today is between the last sunday of march and september 03:00 returns true
 */

export const DSTorST = dayjs().isAfter(getLastSundayOfMonth(3).hour(3))
    &&
    dayjs().isBefore(getLastSundayOfMonth(9).hour(3)) ? 2 : 1;
